module.exports = __webpack_public_path__ + "static/media/delete_black.51aff4af.svg";